import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {filter, take, tap} from 'rxjs/operators';
import { LicensePackageEntity } from '../entities/license-package.entity';
import { State } from '../State';
import { ResolverLoadLicensePackage } from '../State/actions/resolver.actions';

@Injectable({
    providedIn: 'root'
})
export class LicensePackageResolver implements Resolve<LicensePackageEntity[]> {
    constructor(private store: Store<State>) {
    }

    resolve() {
        const value$ = this.store.select(state => state.licenses.licensePackages);
        value$
            .pipe(
                filter(value => !value),
                take(1),
                tap(() => {
                    if (localStorage.getItem('token') != null) {
                        this.store.dispatch(new ResolverLoadLicensePackage());
                    }
                })
            )
            .subscribe();

        return value$.pipe(
            filter(value => !!value),
            take(1)
        );
    }
}
